import type { EntriRouter } from "replo-publisher/src/trpc/routers/entri";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: entriRouter,
  client: entriClient,
  utils: entriUtils,
  options: entriOptions,
} = createTrpcRouterConfig<EntriRouter>({
  path: "entri",
  queryClient: getNamespacedQueryClient("entri"),
});

export { entriClient, entriRouter, entriUtils, entriOptions };
